export default __webpack_public_path__ + "static/media/service2.ff1ac268.png";